export default function gpt() {
  return '<script src="https://securepubads.g.doubleclick.net/tag/js/gpt.js" async></script>';
}
